import { render, staticRenderFns } from "./PurchaseIntro.vue?vue&type=template&id=65ce120e&"
import script from "./PurchaseIntro.vue?vue&type=script&lang=js&"
export * from "./PurchaseIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports